import { render, staticRenderFns } from "./SelectButton.vue?vue&type=template&id=772d6401&scoped=true&"
import script from "./SelectButton.vue?vue&type=script&lang=js&"
export * from "./SelectButton.vue?vue&type=script&lang=js&"
import style0 from "./SelectButton.vue?vue&type=style&index=0&id=772d6401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d6401",
  null
  
)

export default component.exports